<template>
  <path
    stroke-linecap="round"
    stroke="currentColor"
    stroke-linejoin="round"
    stroke-width="2"
    fill="none"
    d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
  />
</template>
